import React from 'react';

/**
 * Noor brand mark — LOGO OFICIAL (2026-10-20): ivory serif "N", enlarged to
 * fill most of the square, on a navy squircle with a thin gold border.
 *
 * The N is the exact glyph of the official logo file (noor-logo-OFICIAL),
 * traced to a vector path so it is identical on every platform and stays
 * crisp at any size. Do NOT redraw it with a font: the website, Stripe,
 * Facebook, YouTube, Apple, Twilio and Drive must all show this same mark.
 *
 * Colors (verified from the official file): navy #16243F, gold #B08A2E,
 * ivory #F4ECD6.
 *
 * - <NoorBadge/>  : the squircle badge mark only (header, footer, favicon)
 * - <NoorLockup/> : badge + "NOOR PASSPORT SERVICES" wordmark + gold tagline
 */

const NAVY = '#16243F';
const GOLD = '#B08A2E';
const IVORY = '#F4ECD6';

// Official N glyph, in a 1024 x 1024 coordinate space.
const N_PATH = 'M212.3 184.3L212.0 186.3L217.7 217.3L220.0 235.0L220.3 242.7L221.3 250.7L221.3 256.0L221.7 256.3L222.3 284.7L222.7 285.0L222.7 765.3L221.7 773.3L220.3 778.7L218.7 783.3L216.0 788.7L210.0 797.3L203.0 804.3L198.3 808.0L192.3 811.7L182.3 815.7L172.0 817.3L151.3 817.3L150.7 818.0L150.7 825.3L151.3 826.0L421.7 826.0L422.7 825.0L422.3 823.7L422.7 818.7L422.0 817.3L401.3 817.3L392.3 816.0L383.7 813.0L379.0 810.7L373.0 806.7L366.0 800.3L361.7 795.3L358.0 790.0L354.3 782.7L351.7 773.7L350.7 766.3L350.7 763.0L349.7 761.3L350.0 759.7L349.7 758.7L349.7 411.0L350.0 410.7L349.7 408.0L351.0 407.3L804.3 838.7L811.7 838.7L812.0 836.7L808.7 820.7L808.7 818.3L806.0 802.0L806.0 799.0L803.7 780.3L802.7 763.0L802.3 762.7L802.3 756.7L802.0 756.3L801.7 731.7L801.3 731.3L801.3 261.0L801.7 260.7L801.7 257.0L803.7 246.7L806.0 240.0L811.3 230.7L815.0 226.0L823.0 218.3L832.7 212.0L843.7 208.0L851.7 206.7L872.3 206.7L873.0 206.3L873.3 205.3L873.0 205.0L873.0 199.3L873.3 199.0L872.7 198.0L602.0 198.0L601.3 198.7L601.7 200.7L601.3 205.7L602.0 206.7L624.0 206.7L630.7 207.7L639.7 210.3L645.3 213.0L649.7 215.7L654.3 219.3L660.3 225.3L664.0 230.0L668.0 236.3L670.7 242.3L673.0 250.7L674.3 261.3L674.3 611.7L674.0 612.0L674.3 615.0L673.3 615.7L226.0 189.3L220.3 184.3Z';
export function NoorBadge({
  size = 36,
  className = '',
  title = 'Noor Passport Services'
}: {
  size?: number;
  className?: string;
  title?: string;
}) {
  return <svg width={size} height={size} viewBox="0 0 1024 1024" role="img" aria-label={title} className={className} data-id="element-334" data-mp="zws6vhji2m7f">
      <rect x="68.5" y="68.5" width="887" height="887" rx="210" ry="210" fill={NAVY} stroke={GOLD} strokeWidth="13" data-id="element-335" data-mp="1nmw5fahtzvrk" />
      <path d={N_PATH} fill={IVORY} data-id="element-336" data-mp="1dnngwx5qj9cl" />
    </svg>;
}
export function NoorLockup({
  className = '',
  badgeSize = 96
}: {
  className?: string;
  badgeSize?: number;
}) {
  return <div className={`flex flex-col items-center text-center ${className}`} data-id="element-337" data-mp="27yrlz50dy8m">
      <NoorBadge size={badgeSize} data-id="element-338" data-mp="78mj0lx5gh3d" />
      <p className="font-heading font-bold tracking-wide mt-4" style={{
      color: IVORY,
      fontSize: 'clamp(20px, 4vw, 30px)',
      letterSpacing: '0.06em'
    }} data-id="element-339" data-mp="78wdalp89aev">
        NOOR PASSPORT SERVICES
      </p>
      <p className="italic mt-1" style={{
      color: GOLD,
      fontFamily: "Georgia, 'Times New Roman', serif",
      fontSize: 'clamp(14px, 2.4vw, 18px)'
    }} data-id="element-340" data-mp="2ugaidsqj9mvp">
        We prepare. You submit. Simple.
      </p>
    </div>;
}